define('lib/plugin/PluginAbstract',['require','marionette','lib/plugin/PluginBroker'],function (require) {	

	var Marionette = require('marionette');
	var PluginBroker = require('lib/plugin/PluginBroker');

	return Marionette.Object.extend({
		
		_stepManager: null,
		
		/**
		 * If you want to add your own step for booking process or override step
		 * you should implement this method and return object 
		 * inherated from lib/controller/booking/BaseStep
		 * Make sure that <code>step</code> is equal to step that you want override/add  
		 * 
		 * @see lib/controller/booking/BaseStep
		 * @param String step - step name
		 * @param Object params - step parameters
		 * @return BaseStep|null
		 */
		getStep: function (step, params) {
		},
		
		/**
		 * Here you can arrange steps and add new steps
		 * The <code>steps</code> is array that contain current steps arrangement
		 * To modify you should return new steps arrangement or null
		 * 
		 * @param Array steps
		 * @return Array|null
		 */
		modifySteps: function (steps) {
		},
		
		/**
		 * Sets booking steps manager for plugins. it can be used to subscrib and trigger events
		 * 
		 * @param BookingStepManager
		 */
		setStepManager: function (manager) {
			this._stepManager = manager;
			
			this.initStepManagerEvents();
		},
		
		/**
		 * After step manager inited you can subscrib and trigger manager events
		 */
		initStepManagerEvents: function () {
		},

        /**
         * Validate plugin data. If plugin returns false the saving will not start.
         *
         * @return Boolean
         */
        validate: function () {
            return true;
        },

		getValidationError: function() {
			return null;
		},

		/**
		 * Triggers event in plugin broker
		 *
		 * @param String event
		 * @param Array args
		 */
		triggerPluginEvent: function (event, args) {
        	var broker = PluginBroker.getInstance();

			broker.triggerMethod.apply(broker, [event].concat(args));
		}
		
	});
	
});
